import { QuestionIcon } from '@chakra-ui/icons';
import {
  Box,
  Link,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  Portal,
  useColorModeValue,
} from '@chakra-ui/react';
export function HelperTooltip({ content, helpLink, placement = 'right' }) {
  const linkColor = useColorModeValue('brand.500', 'brand.400');
  const popoverBg = useColorModeValue('white', 'gray.700');
  const popoverBorder = useColorModeValue('gray.200', 'gray.600');
  const hasBodyText = content != null && content !== '';

  return (
    <Popover
      placement={placement}
      trigger="click"
      closeOnBlur={true}
      gutter={12}
      isLazy
      lazyBehavior="keepMounted"
    >
      <PopoverTrigger>
        <QuestionIcon
          color={'secondaryGray.600'}
          mx={1}
          boxSize={'14px'}
          verticalAlign={'text-top'}
          cursor="pointer"
          _hover={{ color: linkColor }}
        />
      </PopoverTrigger>
      <Portal>
        <PopoverContent
          rootProps={{ zIndex: 'popover' }}
          bg={popoverBg}
          borderColor={popoverBorder}
          maxW="400px"
          w="400px"
          boxShadow="xl"
        >
          <PopoverArrow bg={popoverBg} />
          <PopoverBody p={4} maxH="70vh" overflowY="auto">
            <Box fontSize="sm">
              {helpLink && (
                <Box mb={hasBodyText ? 3 : 0}>
                  <Link
                    href={`/help#${helpLink}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    color={linkColor}
                    fontSize="sm"
                    fontWeight="600"
                    textDecoration="underline"
                    _hover={{ opacity: 0.8 }}
                  >
                    Learn more →
                  </Link>
                </Box>
              )}
              {hasBodyText && (
                <Box whiteSpace="normal" wordBreak="break-word">
                  {content}
                </Box>
              )}
            </Box>
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
}
